<template>
   <dashboard-layout>
      <v-container fluid class="down-top-padding py-0">
         <BaseBreadcrumb
            :title="page.title"
            :icon="page.icon"
            :breadcrumbs="breadcrumbs"
         ></BaseBreadcrumb>
         <v-row>
            <v-col cols="12">
               <table-resolutions></table-resolutions>
            </v-col>
         </v-row>
      </v-container>
   </dashboard-layout>
</template>

<script>
import BaseBreadcrumb from '@/components/BaseBreadcrumb.vue'
import DashboardLayout from '@/Layouts/DashboardLayout.vue'
import TableResolutions from './Tables/TableResolutions.vue';

export default {
   name: "MOAResolutions",

   props: ['user'],

   data() {
      return {
         page: {
         title: "Manage Resolutions",
         },
         breadcrumbs: [
            {
               text: "Dashboard",
               disabled: false,
               to: "/dashboard",
            },
            {
               text: "Resolutions",
               disabled: true,
            },
         ],
      }
   },

   components: {
      DashboardLayout,
      BaseBreadcrumb,
      TableResolutions,
   },

   methods: {

   },

   computed: {

   }


};
</script>

<style>
</style>
